import './stats.scss';

import React from 'react';

const Stats = ({stats}) => {
  return (
    <div className="stats">
      <table>
        <tbody>
          <tr>
            <th>M</th>
            <th>APL</th>
            <th>GA</th>
            <th>DF</th>
            <th>SV</th>
            <th>W</th>
          </tr>
          <tr>
            <td>{stats.M}</td>
            <td>{stats.APL}</td>
            <td>{stats.GA}</td>
            <td>{stats.DF}</td>
            <td>{stats.SV}</td>
            <td>{stats.W}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Stats;
